import Vue from 'vue'
// vant 自定义icon
import '@/assets/style/iconfont.css'

import {
  Row, Col, Icon, Cell, CellGroup,
  CheckboxGroup,
  Image,
  Loading,
  ActionSheet,
  Tag,
  Field,
  GoodsActionIcon,
  GoodsActionButton,
  Toast,
  Dialog,
  Lazyload,
  RadioGroup,
  Radio,
  Switch,
  SubmitBar,
  GoodsAction,
  Card,
  Checkbox,
  Button,
  TreeSelect,
  List, ImagePreview,
  Swipe, SwipeItem,
  PullRefresh,
  Popup,
  NavBar,
  Uploader,
  Tabbar, TabbarItem,
  Divider,
  Picker,
  Skeleton,
  DropdownMenu,
  DropdownItem,
  IndexAnchor,
  IndexBar,
  Tab, Tabs,
  Collapse, CollapseItem,Cascader,
} from 'vant'
Vue.use(Lazyload)
  .use(IndexAnchor)
  .use(IndexBar)
  .use(Icon)
  .use(Image)
  .use(Loading)
  .use(Field)
  .use(Uploader)
  .use(Divider)
  .use(Tabbar)
  .use(TabbarItem)
  .use(Row)
  .use(GoodsActionIcon)
  .use(Tag)
  .use(GoodsActionButton)
  .use(CheckboxGroup)
  .use(Col)
  .use(Cell)
  .use(CellGroup)
  .use(Radio)
  .use(Switch)
  .use(RadioGroup)
  .use(SubmitBar)
  .use(GoodsAction)
  .use(Card)
  .use(Checkbox)
  .use(Button)
  .use(TreeSelect)
  .use(List)
  .use(ImagePreview)
  .use(Swipe)
  .use(SwipeItem)
  .use(PullRefresh)
  .use(Popup)
  .use(NavBar)
  .use(ActionSheet)
  .use(Toast)
  .use(Dialog)
  .use(Picker)
  .use(Skeleton)
  .use(DropdownItem)
  .use(DropdownMenu)
  .use(Tab)
  .use(Tabs)
  .use(Collapse)
  .use(CollapseItem)
  .use(Cascader)